<script>
import { mapGetters } from "vuex";
import { ProgressBar } from "uiv";
export default {
  components: { ProgressBar },
  computed: {
    ...mapGetters([
      "isMaster",
      "isPreloader",
      "getPreloaderUrl",
      "getPreloaderPorcentaje"
    ])
  }
};
</script>

<template>
  <div
    v-if="isPreloader"
    class="jumbotron preloader"
    :style="{backgroundImage: 'url(' + getPreloaderUrl +')'}"
  >
    <h1>Buscando...</h1>
    <p>Buscando los mejores circuitos.</p>
    <progress-bar v-model="getPreloaderPorcentaje" striped active />
  </div>
</template>

<style lang="scss" scoped>
.preloader {
  background: center no-repeat;
  background-size: cover;
  position: relative;
  padding: 45px 35px 35px;
  overflow: hidden;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12) !important;

  &::before {
    display: block;
    content: "";
    background-color: rgba(44, 62, 80, 0.4);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
  }

  > * {
    position: relative;
    z-index: 2;
  }

  > h1 {
    color: #fff;
    text-shadow: 1px 1px 1px #333;
  }

  > p {
    color: #d9d9d9;
  }

  > .progress {
    margin: 0;
    height: 13px;
    padding: 2px;
    background: rgba(255, 255, 255, 0.8);
    box-shadow: none;
    border-radius: 3px;

    > .progress-bar {
      border-radius: 3px;
      background-color: #808e9b;
    }
  }
}
</style>